export const config = {
  title: "Kornfeld Tree Service | Quality Tree Care in Wichita, KS",
  meta: {
    description:
      "Kornfeld Tree Service offers professional tree removal, trimming, and stump grinding services in Wichita, KS. Committed to excellence since 2021.",
    keywords: [
      'Kornfeld Tree Service',
      'Tree Removal Wichita KS',
      'Tree Trimming',
      'Stump Grinding',
      'Professional Tree Care',
      'Landscaping Services',
      'Insured Tree Service',
      'Local Tree Experts',
      'Tree Maintenance',
      'Wichita Tree Services'
    ],
    author: "Kornfeld Tree Service",
    canonicalUrl: 'https://www.kornfeldtreeservice.com/',
  },
  sections: {
    header: {
      businessName: "Kornfeld Tree Service",
    },
    sectionB: {
      heroTitle: "Kornfeld Tree Service",
      heroSubtitle: 'Quality, Local Service for All Your Landscaping Needs',
      learnAboutText: 'Discover Our Tree Services',
      phoneNumber: '3164526283',
      phoneLabel: '(316) 452-6283',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/669329658/photo/chainsaw.jpg?s=612x612&w=0&k=20&c=pdPwbg_F66FQ7RS9ShwtZ8MAj2KUKeDzLGrFVkzi5h4=",
      cardData: [
        {
          title: 'Experienced & Insured',
          description: 'Providing professional tree services since 2021 with full insurance coverage.',
        },
        {
          title: 'Comprehensive Tree Care',
          description: 'Specializing in tree removal, trimming, and stump grinding to maintain your landscape.',
        },
        {
          title: 'Customer Satisfaction',
          description: 'Committed to excellence and going the extra mile to ensure client satisfaction.',
        },
      ],
      description:
        "Kornfeld Tree Service is dedicated to delivering top-quality tree care solutions in Wichita, KS. Our services include tree removal, trimming, and stump grinding, all performed by experienced professionals committed to maintaining the beauty and safety of your property.",
    },
    sectionC: {
      servicesTitle: 'Our Tree Services',
      servicesDescription:
        "Explore our range of professional tree care services designed to keep your landscape healthy and beautiful.",
      cards: [
        {
          title: 'Tree Removal',
          description:
            'Safe and efficient removal of trees, regardless of size, ensuring the safety and aesthetics of your property.',
          imageSrc: 'https://media.istockphoto.com/id/186690958/photo/tree-stump-grinding.jpg?s=612x612&w=0&k=20&c=X67KIKnarKFWI2MPRj4NVCDBVZdkJeUp-xJEaU9HWG8=',
          imageAlt: 'Tree Removal',
        },
        {
          title: 'Tree Trimming',
          description:
            'Expert trimming services to promote healthy growth and enhance the appearance of your trees.',
          imageSrc: 'https://media.istockphoto.com/id/172624371/photo/tree-pruning-service-with-wood-chipper-and-workers-on-street.jpg?s=612x612&w=0&k=20&c=zcV0tYaEj6aShsb3PNMqd7l_rp_HF9-2Cieh3U5gdUk=',
          imageAlt: 'Tree Trimming',
        },
        {
          title: 'Stump Grinding',
          description:
            'Complete stump grinding services to remove unsightly stumps and prevent potential hazards.',
          imageSrc: 'https://media.istockphoto.com/id/1454689487/photo/stump-grinder.jpg?s=612x612&w=0&k=20&c=tu-q2pm-TPODKajBQWala9KUeAAZNar0sXWn2iczR6M=',
          imageAlt: 'Stump Grinding',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Emergency Tree Services',
        'Landscaping',
        'Tree Health Assessments',
        'Brush Clearing',
        'Storm Damage Cleanup',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/bbc7a68ffbe84fe98d82f628b0a5f522.jpg/v1/fill/w_550,h_660,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/bbc7a68ffbe84fe98d82f628b0a5f522.jpg',
        alt: "Kornfeld Tree Service Team",
      },
      aboutText: [
        "Established in 2021, Kornfeld Tree Service is a family-owned business committed to providing exceptional tree care services in Wichita, KS.",
        "Our mission is to deliver quality workmanship and ensure customer satisfaction through reliable and professional services.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Kornfeld Tree Service Logo",
      businessName: "Kornfeld Tree Service",
      contact: {
        phone: '3164526283',
        phoneLabel: '(316) 452-6283',
        email: 'ethankornfeld03@gmail.com',
        website: 'https://www.kornfeldtreeservice.com/',
        address: 'Wichita, KS',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: 'Wichita, KS',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28927.123456789!2d-97.3456789!3d37.6789123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87bae1234567890b%3A0xabcdef1234567890!2sWichita%2C%20KS!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
